import reject from 'lodash/reject'
import * as types from '../actions/types';
import initialState from './initialState';

export default function assignmentsReducer(state = initialState.assignments, action) {
  switch (action.type) {
    case types.GET_ASSIGNMENTS_SUCCESS:
      return action.payload;
    case types.ASSIGNMENTS_UPDATE_ENTITY:
      return state.map(item => item.id === action.payload.id ? {...item, ...action.payload} : item)
    case types.ASSIGNMENTS_DROP:
      return reject(state, item => item.id === action.payload)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/assignmentsReducer.js